module.exports = __webpack_public_path__ + "static/media/shap1.94de0520.png";